/**
 * Re-export useMediaQuery and SSR helpers from VueUse so we get maintained behavior
 * (SSR, ssrWidth, pxValue for units) without duplicating logic.
 * See https://vueuse.org/core/useMediaQuery/
 */
export { useMediaQuery as default, provideSSRWidth, useMediaQuery, useSSRWidth } from '@vueuse/core';

/**
 * No-op for backwards compatibility with test setup. VueUse's useMediaQuery does not
 * use a shared cache, so there is nothing to clear.
 */
export function clearQueryCache(): void {}
